export const GET_ALL_BONUSES = "GET_ALL_BONUSES"
export const GET_ALL_BONUSES_RESPONSE_SUCCESS =
  "GET_ALL_BONUSES_RESPONSE_SUCCESS"
export const CREATE_BONUS = "CREATE_BONUS"
export const UPDATE_BONUS = "UPDATE_BONUS"
export const DELETE_BONUS = "DELETE_BONUS"
